import styled from "styled-components";
import {COLORS} from "shared/consts";

export const SubmitModalContent = styled.div`
    padding: 30px 20px 20px 20px;
    display: flex;
    position: relative;
    flex-direction: column;
`


export const  SubmitModalHeaderRow = styled.div`
    display: flex;
    margin-bottom: 8px;
    justify-content: center;
    
    h3 {
        color: ${COLORS.FG.DEFAULT};
        text-align: center;
        
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
    }

    svg {
        position: absolute;
        cursor: pointer;
        top: 10px;
        right: 10px;
    }
`;

export const SubmitModalText = styled.p`
    color: ${COLORS.FG.DEFAULT};

    font-size: 14px;
    text-align: center;
    margin-bottom: 12px;
    font-weight: 400;
    line-height: 20px;
`

export const SubmitModalButtonsRow = styled.div`
    display: flex;
    gap: 12px;
    
    button {
        width: 100%!important;
    }
`